/**
 * ACF filter to stop escaping select2 markup.
 */

document.addEventListener( 'DOMContentLoaded', function() {
	if ( typeof acf !== 'undefined' ) {
		// eslint-disable-next-line no-unused-vars, camelcase
		acf.add_filter( 'select2_escape_markup', function( escaped_value, original_value, $select, settings, field, instance ) {
			// return the unescaped values because we don't want the markup to be escaped.
			// eslint-disable-next-line camelcase
			return original_value;
		} );
	}
} );
